import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 436px;
  min-width: 490px;
  padding: 16px;

  flex: 1;

  position: relative;

  background-color: ${({ theme }) => theme.colors.white};

  box-shadow: ${({ theme }) => theme.shadow.default};
  border-radius: 12px;

  > h3 {
    font-size: 2vh;
    font-weight: 600;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.gray[900]};
  }

  aside {
    height: 136px;
    display: flex;
    justify-content: center;

    span {
      width: fit-content;
      margin-top: 36px;
    }
  }
`;
